import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { environment } from 'src/environments/environment';
import { CartModuleConsts } from '../../contants';
import { CartService } from '../../services/cart.service';


declare let Frames: any, payButton: any;
@Component({
    selector: 'app-mobile-payment',
    templateUrl: './mobile-payment.component.html',
    styleUrls: ['./mobile-payment.component.scss'],
    standalone: false
})
export class MobilePaymentComponent implements OnInit {
  status: boolean = false;
  gatewayToken:any;
  saveCardValue: any;
  constructor(private cartService: CartService, private statePersist: StatePersistService,
    private alertService: AlertService, private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router, private titleService: Title,
    private location: Location) { }


  newpaymentEvent(){
    document.body.classList.add("saved-payment-box");
    document.body.classList.remove("new-payment-box");
    document.getElementById('savecardpay-button').classList. add('savecard-payment');
    document.getElementById('pay-button').classList. remove('newcard-payment');
}
paymentEvent(){
  document.body.classList.add("new-payment-box");
  document.body.classList.remove("saved-payment-box");
  document.getElementById('pay-button').classList. add('newcard-payment');
}


  ngOnInit(): void {
    this.titleService.setTitle(CartModuleConsts.PAYMENT_PAGE_TITLE);
    setTimeout(() => {

    payButton = document.getElementById("pay-button");
    var form = document.getElementById("payment-form");
    

    setTimeout(function(){ 
      Frames.init(
        
        {
          publicKey: this.stateService.checkoutToken,
          style: {
            base: {
              color: 'black',
              fontSize: '14px',
            },
            autofill: {
              backgroundColor: 'yellow',
            },
            hover: {
              color: '#5E6567',
            },
            focus: {
              color: '#5E6567',
            },
            valid: {
              color: 'green',
            },
            invalid: {
              color: 'red',
            },
            placeholder: {
              base: {
                color: 'gray',
              },
              focus: {
                border: 'solid 1px transparent',
              },
            },
          },
        }
        );

        
  
      Frames.addEventHandler(
        Frames.Events.CARD_VALIDATION_CHANGED,
        function (event) {
        
          payButton.setAttribute('disabled', String(!Frames.isCardValid()))
          if (Frames.isCardValid()){
            payButton.removeAttribute("disabled")
          }
          else{
            payButton.setAttribute('disabled', String(!Frames.isCardValid()))
          }
          
        }
      );
  
      form.addEventListener("submit", (event) => {
        event.preventDefault();
        document.getElementById('card-token').setAttribute('value', '')
        Frames.submitCard()
          .then((data) => {
            
            document.getElementById('card-token').setAttribute('value', data.token)
            document.getElementById('submit-savecard').click()
          })
          .catch(function (error) {
            document.getElementById('card-token').setAttribute('value', '')
            payButton.removeAttribute("disabled")
          });
      });

     },500);
      }, 500);
  }

  changeSaveCard(event){
    this.saveCardValue = event.target.checked
  }

  test(){
    let token;
    token = document.getElementById('card-token').getAttribute('value')
    this.location.replace('/mycart/mobile/payment/'+'?token='+token+'&saveCard'+this.saveCardValue)
  }

}
